// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum TransactionStatus {
	PendingVoucherUpload = 1,
	PendingSend = 2,
	PendingConciliation = 3,
	Completed = 4,
	Cancelled = 5,
	Rejected = 6,
}
